<template>
  <div class="upload_softw">
    <!--设定》 上传固件 -->
    <!-- 表格删选 -->
    <div class="flex_bet" style="margin-bottom: 20px;">
      <div>
        <el-select v-model="seachObj.deviceModel" :placeholder="$t('adminView.hardwareVersion')" clearable filterable
          style="width: 300px; padding-right: 10px" @change="changeSearch">
          <el-option v-for="(item, index) in deviceModelOptions" :key="index" :label="item" :value="item" />
        </el-select>
        <el-input v-model="seachObj.deviceVersion" clearable :placeholder="$t('adminView.Version')"
          @clear="changeSearch" style="width: 300px;">
          <el-button slot="append" icon="el-icon-search" @click="changeSearch" />
        </el-input>
        <el-select v-model="seachObj.testVersion" :placeholder="$t('adminView.versionType')" clearable filterable
          style="width: 300px; padding-left: 10px;padding-right: 10px" @change="changeSearch">
          <el-option v-for="item in testVersionOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </div>
      <!-- 上传固件 -->
      <el-button type="primary" icon="el-icon-upload2" @click="uploadVersion">上传固件</el-button>
    </div>

    <el-table v-loading="loading" :data="tableData" style="margin-bottom: 20px;"
      :default-sort="{ prop: 'date', order: 'descending' }" border>

      <el-table-column :label="$t('adminView.FileName')" prop="deviceName" align="center" width="200" />
      <!-- 前端过滤 -->
      <el-table-column prop="deviceModel" :label="$t('adminView.hardwareVersion')" align="center">
        <template slot-scope="scope">
          <el-link type="primary" @click="clickHardwareVersion(scope.row.deviceModel)">{{ scope.row.deviceModel }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column :label="$t('adminView.SystemVersion')" prop="deviceVersion" align="center" />

      <el-table-column :label="$t('adminView.versionType')" prop="testVersion" align="center">
        <template slot-scope="scope">
          <div style="text-align: center;">{{ scope.row.testVersion == 0 ? $t('adminView.produce') :
                  $t('adminView.test') }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('warningPage.Remark')" prop="remark" align="center" width="200">
        <template slot-scope="scope">
          <p class="truncate-2-lines" @click="edit(scope.row)" >
            <el-button type="text" icon="el-icon-edit"title="修改备注信息" />
            {{ scope.row.remark }}
          </p>
        </template>
      </el-table-column>
      <el-table-column :label="'产品型号'" prop="productModel" align="center" />
      <el-table-column :label="$t('QR.Uploader')" prop="createName" align="center" />
      <el-table-column :label="$t('QR.Uploadtime')" prop="createTime" sortable align="center" width="180">
        <template slot-scope="scope">
          {{ timeHandle(scope.row.createTime) }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('yhubReport.Operating')" align="center" width="140">
        <template slot-scope="scope">
          <!-- <div style="text-align: center;"> -->

          <!-- <el-button v-if="!scope.row.isViewRemark" type="primary" icon="el-icon-close" 
              @click="close(scope.$index)" />
            <el-button v-if="!scope.row.isViewRemark" type="primary" icon="el-icon-check" 
              @click="submit(scope.row, scope.$index)" /> -->

          <el-button type="primary" icon="el-icon-download" size="mini" @click="downLoadFile(scope.row)" />
          <el-button v-if="isAdmin" type="danger" icon="el-icon-delete" size="mini" @click="deleteOne(scope.row)" />
          <!-- </div> -->
        </template>
      </el-table-column>

    </el-table>

    <el-pagination v-if="pageshow" background current-page.sync="listQuery.pageInfo.page"
      :page-sizes="listQuery.pageInfo.pageList" :page-size="listQuery.pageInfo.limit"
      layout="total, sizes, prev, pager, next, jumper" :total="listQuery.pageInfo.total" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" />

    <!-- 上传版本 -->
    <el-dialog :close-on-click-modal="false" :title="$t('adminView.Upload')" :visible.sync="isShowUploadFilePop">

      <div style="width: 50%; margin: 0 auto;">
        <el-steps :active="currentStep" finish-status="success">
          <el-step :title="$t('table1.select_file')"></el-step>
          <el-step :title="$t('table1.complete_sub')"></el-step>
        </el-steps>
      </div>

      <div v-show="currentStep == 0" class="upload_box">
        <el-upload ref="upload" drag class="upload-demo" action="" :on-change="handleChange" :file-list="fileList"
          :auto-upload="false">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">{{ $t('table1.drag_here') }}</div>
          <!-- <el-button slot="trigger" size="small" type="primary" :loading="uploading">{{ $t('QR.SelectFile') }}
            </el-button> -->
          <!-- <div class="el-upload__tip" slot="tip">
            {{ $t('adminView.Example') }}
            <p>YHUB {{ $t('table1.series') }}：GPD_YHUB11_181101_ver136.bin</p>
            <p>Charger {{ $t('table1.series') }}：GPD_C0404_PY_SC78660804-01_VER12.bin</p>
            <p>CTB {{ $t('table1.series') }}：GPD_C0702_181101_ver136.bin</p>
          </div> -->
        </el-upload>
      </div>

      <el-form v-show="currentStep == 1" ref="dataForm" :rules="rules" :model="formData" label-position="right"
        label-width="160px" style=" margin: 20px auto;">
        <!-- 上传文件 -->
        <!-- <el-form-item :label="$t('adminView.File')">
          
        </el-form-item> -->
        <el-form-item :label="$t('BondOrUpdateDevice.Name')" prop="deviceName">
          <span>{{ formData.deviceName }}</span>
        </el-form-item>

        <el-form-item :label="$t('adminView.Version')" prop="deviceVersion">
          <el-input @input="validateInteger" v-model="formData.deviceVersion" />
        </el-form-item>
        <el-form-item :label="'设备类型'" prop="dm">
          <el-autocomplete style="width: 100%;" v-model="formData.dm" :fetch-suggestions="querySearch"
            @select="handleSelect"></el-autocomplete>
        </el-form-item>
        <el-form-item :label="'产品型号(部件)'" prop="productModel">
          <el-input v-model="formData.productModel" />
        </el-form-item>
        <template v-if="formData.dm == 'SC' || formData.dm == 'XC' || formData.dm == 'CC'">
          <el-form-item :label="'充电器型号'">
            <div class="flex_row">
              <el-select v-model="chargerNum" style="width: 100%;" @change="handleSelect">
                <el-option v-for="item in chargerOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <el-input v-model="chargerNum" placeholder="自定义，例如：11"/>
            </div>
          </el-form-item>
          <el-form-item :label="'客户'" v-if="chargerNum != '07'">
            <div class="flex_row">
              <el-select v-model="clientNum" style="width: 100%;">
                <el-option v-for="item in clientOptions1" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <el-input v-model="clientNum" placeholder="自定义，例如：08" />
            </div>
          </el-form-item>
          <el-form-item :label="'硬件版本'">
            <el-input v-model="hardNum" placeholder="自定义，例如：01" @blur="handleSelect"/>
          </el-form-item>
        </template>

        <el-form-item :label="$t('adminView.versionType')" prop="testVersion">
          <el-radio v-model="formData.testVersion" :label="1">{{ $t('adminView.test') }}</el-radio>
          <el-radio v-model="formData.testVersion" :label="0">{{ $t('adminView.produce') }}</el-radio>
        </el-form-item>
        <el-form-item :label="$t('warningPage.Remark')" prop="remark">
          <el-input v-model="formData.remark" type="textarea" :rows="2" />
        </el-form-item>
        <div class="dialog-footer">
          <el-button @click="cancelUpload">{{ $t('button.Cancel') }}</el-button>
          <el-button type="primary" @click="uploadFileAndCommit">{{ $t('button.Submit') }}
          </el-button>
        </div>

      </el-form>

    </el-dialog>

    <!-- 版本历史 -->
    <el-dialog :close-on-click-modal="false" :title="$t('adminView.UpdateHistory')" :visible.sync="isShowFWHistoryPop"
      width="80%">
      <el-table v-loading="loadFwHistory" :data="fwHistoryList" style="width: 100%"
        :default-sort="{ prop: 'createTimeRes', order: 'descending' }" border>
        <el-table-column :label="$t('QR.Uploadtime')" sortable prop="createTimeRes" align="center" min-width="15%">
          <template slot-scope="scope">
            <div style="text-align: center;">{{ scope.row.createTimeZh }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="deviceModel" :label="$t('adminView.hardwareVersion')" align="center" min-width="15%" />
        <el-table-column :label="$t('adminView.SystemVersion')" prop="deviceVersion" align="center" min-width="15%" />
        <el-table-column :label="$t('warningPage.Remark')" prop="remark" align="center" min-width="40%" />
        <el-table-column :label="$t('QR.Uploader')" prop="createName" align="center" min-width="15%" />
      </el-table>
    </el-dialog>

    <!-- 修改备注 -->
    <el-dialog :title="'修改备注信息'" :visible.sync="showRemarkPop" width="40%">
      <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="currentRow.remark">
      </el-input>
      <div style="text-align: center; margin-top: 20px;">
        <el-button type="primary" @click="submit">提交</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { pageDeviceSystemVersionList, updateVersionFile, deleteVersion, uploadFile, addVersionFile, deviceSystemVersionHistory, deviceModelList, FWDownload } from '@/api/firmwareUpdate'
import { pagination } from '@/utils/init_table' // 分页
import { getDateAndHour } from '@/utils/updateTime.js'
import { clientOptions, getClientValue, hardwareOptions, getHardwareValue, deviceModels, clientOptionsOfOther, hardwareOptions10048, getClientName, getHardwareName } from './utilsFw'
import { mapState } from 'vuex'

export default {
  name: 'DashboardAdmin',
  components: {},
  data () {
    return {
      dmOptions: [
        { label: 'YHUB11', value: 'YHUB11' },
        { label: 'YHUB12', value: 'YHUB12' },
        { label: 'YHUB13', value: 'YHUB13' },
        { label: 'YhubLite', value: 'YhubLite' },
        { label: 'SC', value: 'SC' },
        { label: 'XC', value: 'XC' },
        { label: 'CC', value: 'CC' }
      ],
      hardwareOptions,
      currentStep: 0,
      // 分页----start
      listQuery: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow: true,
      // 分页----end
      seachObj: {},
      tableData: [],
      isShowUploadFilePop: false,

      formData: {
        "createName": "",
        "createTime": "",
        "delFlag": "",
        "deviceModel": "",
        "deviceName": "",
        "deviceVersion": 0,
        "fileCount": 0,
        "fileName": "",
        "fileSize": 0,
        "id": 0,
        "productModel": "",
        "remark": "",
        "testVersion": 0,
        "updateBy": 0,
        "updateName": "",
        "updateTime": "",
        "updateTotal": 0,
        "versionStatus": 0,
        client: '00',
        hardware: '00',
        dm: ''
      },
      fileList: [],
      uploading: false,
      deviceModelOptions: [],
      isDisabledPop: true, // 提交按钮是否可以编辑,
      loading: true,
      isShowFWHistoryPop: false,
      loadFwHistory: true,
      fwHistoryList: [],
      chargerNum: '',
      chargerOptions: [
        { label: '3024', value: '01' },
        { label: '6048', value: '02' },
        { label: '1524', value: '03' },
        { label: '8080', value: '04' },
        { label: '1724', value: '05' },
        { label: '3548', value: '06' },
        { label: 'CTB', value: '07' },
        { label: '10048', value: '08' },
        { label: '2572', value: '09' },
        { label: '4072', value: '10' },
        { label: '3624', value: '11' },
        { label: '2548', value: '12' },
        { label: '3012', value: '13' }
      ],
      clientNum: '',
      hardNum: '',
      showRemarkPop: false,
      currentRow: {
        remark: ''
      }
    }
  },
  computed: {
    ...mapState(['isAdmin']),
    // 上传固件是否为8080充电器的
    isEighty () {
      const name = this.formData.deviceName
      return name && name.indexOf('C04') >= 0
    },
    isChargerSoft () {
      const name = this.formData.deviceName
      return name && name.indexOf('YHUB') == -1
    },
    clients () {
      let mm = this.formData.deviceModel || ''
      if (mm.indexOf('C0') >= 0) mm = mm.slice(0, 3)
      if (mm == 'GPSC8080' || mm == 'C04' || mm == 'GPSC10048' || mm == 'C08') return clientOptions
      return clientOptionsOfOther
    },
    hardwares () {
      let mm = this.formData.deviceModel || ''
      if (mm.indexOf('C0') >= 0) mm = mm.slice(0, 3)
      if (mm == 'GPSC8080' || mm == 'C04') return hardwareOptions
      if (mm == 'GPSC10048' || mm == 'C08') return hardwareOptions10048
      return [{ value: '01', label: '01' }, { value: '02', label: '02' }, { value: '03', label: '03' }]
    },
    rules () {
      return {
        deviceVersion: [{ required: true, message: this.$t('lease.Cannotbeblanked2'), trigger: 'blur' }],
        dm: [{ required: true, message: this.$t('lease.Cannotbeblanked2'), trigger: ['change', 'blur'] }],
        remark: [{ required: true, message: this.$t('lease.Cannotbeblanked2'), trigger: 'blur' }]
      }
    },
    testVersionOptions () {
      return [{ value: 0, label: this.$t('adminView.produce') },
      { value: 1, label: this.$t('adminView.test') }
      ]
    },
    clientOptions1 () {
      if (this.chargerNum == '01') {
        return [
          { label: 'PY-01', value: '01' },
          { label: 'DI-01', value: '02' },
          { label: 'PY-41/LG-41', value: '03' }
        ]
      }
      return [
        { label: 'PY(默认)', value: '00' },
        { label: 'XB(星邦)', value: '01' },
        { label: 'DI(鼎力)', value: '02' },
        { label: 'ZL(中联)', value: '03' },
        { label: 'XG(徐工)', value: '04' },
        { label: 'LG(临工)', value: '05' },
        { label: 'ZF(中福)', value: '06' }
      ]
    }
  },

  mounted () {
    this.queryList()
    this.getDeviceModel()
  },
  methods: {
    validateInteger () {
      this.formData.deviceVersion = this.formData.deviceVersion.replace(/\D/g, '');
      // 检查是否为负数，如果是则移除负号
      if (this.formData.deviceVersion[0] === '-') {
        this.formData.deviceVersion = this.formData.deviceVersion.replace(/^-/, '');
      }
    },
    querySearch (queryString, cb) {
      var restaurants = this.dmOptions;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter (queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleSelect (item) {
      console.log(item);
      this.pmHandle()
    },
    downLoadFile (row) {
      // console.log(row)
      const fileName = row.deviceName
      FWDownload(fileName)
    },
    cancelUpload () {
      this.currentStep = 0
      this.$refs.dataForm.resetFields();
    },
    timeHandle (time) {
      return getDateAndHour(new Date(time).getTime())
    },
    queryList () {
      var param = {
        'deviceModel': this.seachObj.deviceModel,
        'deviceVersion': this.seachObj.deviceVersion,
        'pageNum': this.listQuery.pageInfo.pageNum,
        'pageSize': this.listQuery.pageInfo.pageSize,
        'testVersion': this.seachObj.testVersion
      }
      this.loading = true
      pageDeviceSystemVersionList(param).then(res => {
        console.log('固件列表：', res)
        this.loading = false
        this.tableData = res.resultModel.list
        this.listQuery.pageInfo.total = res.resultModel.total // 分页
        // var deviceModelOptionsArr = []
        // this.tableData.forEach((v, i) => {
        // v.isViewRemark = true
        //   v.createTimeRes = v.createTime
        //   v.createTime = getDateAndHour(new Date(v.createTime).getTime())
        //   deviceModelOptionsArr.push(v.deviceModel)
        // })
      })
    },
    getDeviceModel () {
      deviceModelList().then(res => {
        console.log('硬件型号：', res)
        // let list = []
        if (res.resultCode == 1001 && res.resultModel) {
          this.deviceModelOptions = res.resultModel
        }
        // deviceModels.forEach(item => {
        //   list.push(item.label)
        // })

        // this.deviceModelOptions = Array.from(new Set(list))
      })
    },
    filterTag (value, row) {
      return row.deviceModel === value
    },
    edit (row) { // 版本描述--编辑
      this.currentRow = JSON.parse(JSON.stringify(row))
      this.showRemarkPop = true;
      // console.log(index)
      // this.tableData[index].remarkTextarea = this.tableData[index].remark
      // this.tableData[index].productModelInput = this.tableData[index].productModel
      // this.tableData[index].isViewRemark = false
      // var obj = JSON.parse(JSON.stringify(this.tableData[index]))
      // this.tableData.splice(index, 1)
      // this.tableData.splice(index, 0, obj)
      // console.log(this.tableData)
      // this.$forceUpdate()
    },
    close (index) { // 版本描述--关闭
      this.tableData[index].remark = this.tableData[index].remarkTextarea
      this.tableData[index].productModel = this.tableData[index].productModelInput
      this.tableData[index].isViewRemark = true
      this.tableData = [...this.tableData]
    },
    submit (row, index) { // 版本描述--提交
      // this.tableData[index].isViewRemark = true
      // this.tableData = [...this.tableData]
      var param = {
        'id': this.currentRow.id,
        'remark': this.currentRow.remark,
        'productModel': this.currentRow.productModel
      }
      updateVersionFile(param).then(res => {
        this.showRemarkPop = false
        if (res.resultCode == 1001) this.queryList()
      })
    },
    deleteOne (row) { // 版本--编辑
      this.$confirm(this.$t('adminView.DeleteVersion'), '', {// '是否确定删除此版本？'
        confirmButtonText: this.$t('button.Confirm'), // '确定'
        cancelButtonText: this.$t('button.Cancel'),
        type: 'warning'
      }).then(() => {
        deleteVersion({ 'id': row.id }).then(res => {
          if (res.resultCode == '1001') {
            this.queryList()
            this.$message({
              type: 'success',
              message: this.$t('lease.Succeed')
            })
          }
        })
      }).catch(() => { })
    },
    uploadVersion () { // 上传版本--弹窗--打开
      this.fileList = [];
      this.chargerNum = '';
      this.clientNum = '';
      this.hardNum = '';
      this.isShowUploadFilePop = true;
      this.currentStep = 0;
      this.formData = {
        "createName": "",
        "createTime": "",
        "delFlag": "",
        "deviceModel": "",
        "deviceName": "",
        "deviceVersion": 0,
        "fileCount": 0,
        "fileName": "",
        "fileSize": 0,
        "id": 0,
        "productModel": "",
        "remark": "",
        "testVersion": 0,
        "updateBy": 0,
        "updateName": "",
        "updateTime": "",
        "updateTotal": 0,
        "versionStatus": 0,
        client: '00',
        hardware: '00',
        dm: ''
      }
    },
    handleChange (file) { // //上传版本--弹窗--上传文件
      console.log(file)
      this.fileList.unshift(file)
      // console.log(fileList)
      this.uploading = true
      var file_name = file.name
      this.$refs.upload.clearFiles()
      const names = file_name.split('.')
      if (file_name.split('.')[names.length - 1] != 'bin') {
        this.$notify({
          title: this.$t('adminView.IncorrectFile'), // '文件名后缀错误！',
          message: this.$t('adminView.FileBin'), // '文件名后缀必须为 "bin" ',
          type: 'error',
          duration: 4000
        })
        this.uploading = false
        return
      }
      this.formData.deviceName = file_name
      //GPD_C0404_PY_SC78660804-01_VER12.bin
      if (file_name.indexOf('_') > -1) { // 校验文件名
        const nameArr = file_name.split('_')
        const version = nameArr[nameArr.length - 1].split('.')[0]
        this.formData.deviceVersion = version.slice(3)
      }
      this.currentStep = 1
    },
    pmHandle () {
      this.formData.productModel = this.formData.dm
      const obj = this.chargerOptions.find(item => item.value == this.chargerNum)
      if (obj) this.formData.productModel = obj.label

      if (this.formData.productModel == 'CTB') {
        this.formData.productModel = 'CTB-' + this.hardNum
      }
    },
    // 点击提交
    uploadFileAndCommit () {
      this.isShowUploadFilePop = false;
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const file = this.fileList[0]
          uploadFile(file).then(res => {
            if (res.resultCode == 1001) {
              console.log('文件上传成功', res)
              this.uploading = false

              this.isDisabledPop = false
              const result = res.resultModel
              this.formData.fileName = result.fileName
              this.formData.fileSize = result.fileSize
              this.formData.fileCount = result.index

              this.confirmPop()
            }else {
              this.$notify({
                title: '',
                message: '文件上传失败',
                type: 'error',
                duration: 2000
              })
            }
          })

        } else {
          console.log('error submit!!')
          return false
        }
      })

    },
    confirmPop () { // 上传版本--弹窗----提交
      this.formData.deviceModel = this.formData.dm
      if (this.formData.dm == 'SC') {
         this.formData.deviceModel = 'C' + this.chargerNum + this.clientNum + this.hardNum
      }
      if (this.formData.dm == 'XC' || this.formData.dm == 'CC') {
         this.formData.deviceModel += this.chargerNum + this.clientNum + this.hardNum
      }
      console.log('提交', this.formData)
      addVersionFile(this.formData).then(res => {
        if (res.resultCode == 1001) {
          this.isShowUploadFilePop = false
          this.queryList()
          this.currentStep = 0
          this.$notify({
            title: '',
            message: this.$t('lease.Succeed'),
            type: 'success',
            duration: 2000
          })
        }
      })
    },
    clickHardwareVersion (deviceModel) { //
      this.isShowFWHistoryPop = this.loadFwHistory = true
      deviceSystemVersionHistory({ deviceModel: deviceModel }).then(res => {
        this.loadFwHistory = false
        if (res.resultCode != 1001 || !res.resultModel) {
          this.fwHistoryList = []
          return
        }
        this.fwHistoryList = res.resultModel || []
        this.fwHistoryList.forEach(v => {
          if (v.createTime) {
            v.createTimeZh = v.createTime.split('T')[0]
            v.createTimeRes = new Date(v.createTime).getTime()
          }
        })
      })
    },
    change (e) {
      this.$forceUpdate()
    },
    // 筛选改变事件
    changeSearch () {
      // 去掉首尾空格
      if (this.seachObj.deviceVersion) this.seachObj.deviceVersion = this.seachObj.deviceVersion.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')
      // if (this.tableObj.companyId) this.tableObj.companyId = this.tableObj.companyId.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')
      this.listQuery.pageInfo.pageNum = 1
      this.pageshow = false
      this.queryList()
      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    // 分页----start
    handleSizeChange (val, e) { // 每一页的列表的行数 10 20 50
      this.listQuery.pageInfo.pageSize = val
      this.queryList()
    },
    handleCurrentChange (val, e) { // 选中某一页
      this.listQuery.pageInfo.pageNum = val
      this.queryList()
    }
    // 分页----end
  }
}
</script>

<style lang="scss" scoped>
.truncate-2-lines {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  // max-height: 3em; /* 设置为行高的两倍 */
  // line-height: 1.5em; /* 这里的行高应与你元素的字体大小和样式相匹配 */
}
.upload_box {
  text-align: center;
  padding: 20px;
}

.el-upload__tip {
  text-align: left;
  padding-left: 30%;
  font-size: 16px;
  line-height: 30px;
}

.dialog-footer {
  text-align: center;
}
p {
  margin: 0;
}

.upload_softw {
  padding: 20px;
  background: #fff;
  .statusDiv {
    width: 100%;
    height: 20px;
    background: #f3f3f3;
    margin-top: 2px;
  }
  .greenStatus {
    width: 33%;
    background: #43d043;
    height: 20px;
  }
  .yellowStatus {
    width: 66%;
    background: #f7f73f;
    height: 20px;
  }
  .redStatus {
    width: 100%;
    background: #fb2b2b;
    height: 20px;
  }
}
</style>
